
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/blogs/[itemID]",
      function () {
        return require("private-next-pages/product/blogs/[itemID].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/blogs/[itemID]"])
      });
    }
  